import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS, HttpBackend, HttpXhrBackend } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AuthModule } from './common/auth.module';
import { CoreAuthenticationService } from '@vfde-fe/ngx-lib/services/core-authentication';
import { CoreConfigurationsLoaderService, CoreConfigurationsLoaderModule } from '@vfde-fe/ngx-lib/services/core-configurations-loader';
import { CoreModule } from './common/core.module';
import { PluginsModule } from './common/plugins.module';
import { environment } from '../environments/environment';
import { AuthenticationService } from '@vfde-fe/ngx-lib/services/authentication';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { APP_PROVIDERS } from './app.providers';
import { SharedModule } from './common/shared.module';
import { ConfigLoaderService } from './common/utils/config-loader.service';
import { CustomTranslateLoader } from './common/utils/custom-translate-loader.component';
import { HTTPClientInterceptor } from './common/utils/http-client-interceptor';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import {APP_BASE_HREF} from '@angular/common';

/** createTranslateLoader */
export function createTranslateLoader (http: HttpClient, config: ConfigLoaderService) {
    return new CustomTranslateLoader(http, config, environment.configPath + 'i18n/', '.json');
}

/** configLoaderFactory */
export function configLoaderFactory (config: ConfigLoaderService) {
    return () => config.load();
}

/** AppModule */
@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        AuthModule.forRoot({
            provide: CoreAuthenticationService,
            useClass: AuthenticationService,
        }),
        CoreModule.forRoot(),
        PluginsModule.forRoot(),
        BrowserModule,
        BrowserAnimationsModule,
        NgxPageScrollCoreModule,
        SharedModule,
        HttpClientModule,
        AppRoutingModule,
        NgIdleKeepaliveModule.forRoot(),
        CoreConfigurationsLoaderModule.forRoot({
            provide: CoreConfigurationsLoaderService,
            useClass: ConfigLoaderService,
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient, CoreConfigurationsLoaderService],
            },
        }),
    ],
    providers: [
        ConfigLoaderService,
        { provide: APP_BASE_HREF, useValue: '/meinvodafone/account' },
        APP_PROVIDERS,
        {
            provide: APP_INITIALIZER,
            useFactory: configLoaderFactory,
            deps: [CoreConfigurationsLoaderService],
            multi: true,
        },
        {   provide: HTTP_INTERCEPTORS,
            useClass: HTTPClientInterceptor,
            multi: true,
        },
        { provide: HttpBackend, useExisting: HttpXhrBackend },
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }
